import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_RESOURCE} from '../../constants/apiUrls';
import {GET_RESOURCE_QUERY_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================

export interface ResourceResponse {
  uuid: string;
  resourceType: string;
  fileName: string;
  fileKey: string;
  title: string;
  description: string;
  examLevel: string;
  updatedAt: string;
  fileSizeInBytes: number;
}

interface Input {
  uuid: string;
  onSuccess: (data: ResourceResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetResource = ({onSuccess, onError, uuid}: Input) => {
  const getResource = async () => {
    const res = await axiosClient.get<ResourceResponse>(GET_RESOURCE(uuid));
    return res.data;
  };

  return useCustomQuery(GET_RESOURCE_QUERY_KEY, getResource, {
    onSuccess,
    onError,
  });
};
